import styled from "styled-components";
import { HomeBannerImg, MobileHomeBanner } from "../../shared/icons";
import { screenSizes } from "../../styles/theme";

export const HomePageSection = styled.div`
  background: url(${HomeBannerImg}) no-repeat center center;
  background-size: cover;
  padding: 18rem 4rem;
  @media (max-width: ${screenSizes.L}px) {
    padding:5rem 1rem 0 1rem;
    font-size: 28px;
    background: none;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: space-between;
    align-items: center;
    gap: 30px;
    @media (max-width: ${screenSizes.L}px) {
      grid-template-columns: 1fr;
      gap: 0px;
    }
    li {
      .right_centent_box {
        max-width: 390px;
        margin-left: auto;
        position: relative;
        padding-top: 50px;
        top: 150px;
        .spot_light_line {
          border-bottom: 1px solid #ffffff20;
          padding-bottom: 15px;
          margin-bottom: 20px;
        }
        p {
          margin-top: 0;
          padding-top: 0;
          color: rgba(9, 28, 0, 0.8);
        }
      }
    }
    button {
      background: transparent;
      transition: all 0.3s;
      border-radius: 50px;
      font-weight: 700;
      width: 100%;
      max-width: 250px;
      text-align: left;
      justify-content: space-between;
      border-width: 2px;
      font-size: 18px;
    }
    .round_btn_banner {
      button {
        max-width: 180px;
        height: 180px;
        width: 100%;
        border-radius: 50%;
        justify-content: center;
        display: flex;
        align-items: center;
        color: #fff;
        background: #ff9d59;
        font-size: 20px;
        line-height: 26px;
        text-align: center;
        margin-left: auto;
      }
    }
  }
  h6 {
    color: rgba(9, 28, 0, 1);
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 16px;
    }
  }
  h1 {
    font-size: calc(4rem + 20px);
    line-height: 130%;
    color: rgba(9, 28, 0, 1);
    font-weight: 400;
    @media (max-width: ${screenSizes.L}px) {
      font-size: calc(2.5rem + 20px);
    }
    span {
      font-weight: 700;
      background-color: #F1E5C0;
    }
  }
  p {
    color: rgba(9, 28, 0, 0.8);
    font-size: 18px;
    padding-block: 10px;
    line-height: 150%;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 16px;
    }
  }
`;

export const MobileBanner = styled.div`
  background: url(${MobileHomeBanner}) no-repeat center center;
  background-size: cover;
  height: 320px;
  margin-top: -15px;
`;

export const TechnologySection = styled.div`
  @media (max-width: ${screenSizes.L}px) {
    padding: 0;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    list-style: none;
    padding-left: 0;
    margin-bottom: 150px;
    @media (max-width: ${screenSizes.L}px) {
      grid-template-columns: 1fr;
      gap: 0px;
      margin-bottom: 0px;
    }
    li {
      h2 {
        color: rgba(255, 255, 255, 1);
        padding-bottom: 20px;
        font-size: calc(2rem + 20px);
        line-height: 64px;
        @media (max-width: ${screenSizes.L}px) {
          font-size: 40px;
          line-height: 40px;
          letter-spacing: -2px;
          padding-block: 20px;
        }
      }
      h5 {
        margin: 0;
        color: rgba(255, 157, 89, 1);
        font-size: 18px;
        font-weight: 500;
        @media (max-width: ${screenSizes.L}px) {
          font-size: 16px;
        }
      }
      .bottom_underline {
        font-weight: 600;
        color: #091c00;
        border-bottom: 1px solid #091c001a;
        padding-bottom: 30px;
      }
      h3 {
        color: #1c201c;
        span {
          color: #ff9d59;
        }
      }
      .select_p_element {
        margin: 0 0 30px;
        color: rgba(255, 255, 255, 1);
      }
      p {
        font-size: 18px;
        font-weight: 400;
        @media (max-width: ${screenSizes.L}px) {
          font-size: 16px;
        }
      }
      h4 {
        font-size: 32px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        @media (max-width: ${screenSizes.L}px) {
         background-color: rgba(9, 28, 0, 1);
         padding: 1rem 1rem 3rem 1rem;
         font-size: 24px;
        }
      }
    }
    .nft_img_content {
      text-align: center;
      img {
        width: 100%;
      }
      h6 {
        letter-spacing: 4px;
        font-size: 16px;
        margin-top: 10px;
        @media (max-width: ${screenSizes.L}px) {
          font-size: 11px;
        }
        span {
          font-weight: 200;
        }
      }
    }
    li {
      &:first-child {
        background-color: rgba(9, 28, 0, 1);
        margin-bottom: -50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-inline: 4rem;
        @media (max-width: ${screenSizes.L}px) {
          padding: 15px;
          text-align: left;
          margin-bottom: -35px;
        }
      }
      &:last-child {
        padding-block: 100px;
        padding-inline: 4rem;
        margin-top: -50px;
        background: rgba(9, 28, 0, 1);
        @media (max-width: ${screenSizes.L}px) {
          margin-top: 0;
          padding-inline: 0;
          padding-block: 0px;
        }
        @media (max-width: ${screenSizes.L}px) {
          padding-top: 0px;
          background: transparent;
        }
      }
    }
  }
`;

export const MiddleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  div {
    flex: 1;
    padding: 1rem 4rem;
    img {
      width: 100%;
      height: auto;
    }
    h5, h2, p, h4 {
      margin: 10px 0;
      font-family: "Manrope", sans-serif;
      line-height: 28px;
    }
    h4 {
      padding-bottom: 10px;
      font-size: 28px;
    }
    h5, h2, h4  {
      rgba(9, 28, 0, 1);
    }
    h2 {
      margin-block: 20px;
      font-size: 50px;
      @media (max-width: ${screenSizes.L}px) {
        font-size: 44px;
        line-height: 36px;
      }
    }
    p {
    color: rgba(9, 28, 0, 0.8);
    font-size: 18px;
    padding-right: 3rem;
    @media (max-width: ${screenSizes.L}px) {
      padding-right: 0;
    }
    }
    h5 {
    font-size: 18px;
    }
  }
  .icon_underline_add {
    padding-top: 3rem;
    padding-inline: 0;
    .link-hover:hover {
      h4 {
      color: #FF9D59;
      }
      cursor: pointer;
      .svg-hover {
        transition: filter 0.3s ease;
        filter: invert(75%) sepia(60%) saturate(487%) hue-rotate(-10deg) brightness(100%) contrast(92%);
      }
    }
    @media (max-width: ${screenSizes.L}px) {
    padding-top: 1rem;
    padding-inline: 0;
  }
  }
  .icon_underline_add div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(9, 28, 0, 0.1);
    padding: 0 !important;
    margin-bottom: 20px;
    padding-inline: 1rem;
    @media (max-width: ${screenSizes.L}px) {
    &:not(:first-child) {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 0;
      padding-bottom: 10px !important;
    }
}
  }
  @media (max-width: ${screenSizes.L}px) {
    flex-direction: column;
    div {
      width: 100%;
      padding: 1rem !important;
      div {
      padding: 0 !important;
      }
    }
    img {
      width: 100%;
      height: auto;
    }
    .icon_underline_add div {
      margin-bottom: 0;
      padding-block: 8px !important;
    }
    .icon_underline_add div h4 {
      font-weight: 600;
      padding-bottom: 0;
      padding-top: 0;
      padding-left: 0px;
      font-size: 20px;
      cursor: pointer;
      }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4rem;
  @media (max-width: ${screenSizes.L}px) {
    padding: 0;
    display: block;
  }
`;

export const TextSection = styled.div`
  max-width: 54%;
  padding-right: 13%;
  margin-top: -5%;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
    max-width: 100%;
    height: auto;
    padding-right: 0;
    margin-top: 0;
  }
`;

export const Highlight = styled.div`
  padding-block: 25px;
  border-bottom: 1px solid rgba(9, 28, 0, 0.1);
  div {
    display: flex;
    align-items: center;
  }
  h1 {
    font-size: 48px;
    margin: 0;
    color: ${(props) => props.color || "#FF9D59"};
  }

  h2 {
    font-size: 42px;
    font-weight: 600;
    margin: 0;
    color: #091c00;
    letter-spacing: -4px;
    @media (max-width: ${screenSizes.L}px) {
    font-size: 35px;
    letter-spacing: -2px;
    font-weight: 700;
    }
  }

  p {
    margin: 5px 0 0;
    color: rgba(9, 28, 0, 1);
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    @media (max-width: ${screenSizes.L}px) {
     line-height: 24px;
    }
  }
`;

export const SubText = styled.div`
  margin-top: 20px;
  p {
    font-size: 18px;
    line-height: 1.6;
    color: rgba(9, 28, 0, 0.8);
  }
`;

export const ImageSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;

  a {
    color: #091C00CC;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    letter-spacing: 0;
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      color: #FF9D59;
      }
  }

  .line-container {
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 10px;
  }

  .line-container::before,
  .line-container::after {
    content: "";
    flex-grow: 1;
    height: 1px;
    background-color: #091C0033;
  }

  .line-text {
    padding: 0 20px;
    white-space: nowrap;
    @media (max-width: ${screenSizes.L}px) {
    padding: 0 5px;
  }
  }

  @media (max-width: ${screenSizes.L}px) {
    max-width: 100%;
    padding: 0rem 1rem 4rem 1rem;
  }

  img {
    // width: 90%;
    height: 100%;
    object-fit: contain;
    border-bottom-left-radius: 40px;

    @media (max-width: ${screenSizes.L}px) {
      width: 100%;
    }
  }
`;

export const ProgressBarContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 30%;
  justify-content: center;
  @media (max-width: ${screenSizes.L}px) {
    width: 100%;
  }
`;

export const ProgressBarWrapper = styled.span`
  position: relative;
  width: 100%;
  height: 8px;
  background-color: #091C001A;
  border-radius: 10px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ width: number }>`
  width: ${(props) => props.width}% !important;
  height: 100%;
  background-color: #FF9D59;
  border-radius: 10px;
  position: absolute;
  left: 0;
  top: 0;
`;

export const Percentage = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #091C00;
`;
